import React from "react";
import styled from "styled-components";
import { getHeaderTheme } from "../../../config/headerTheme";

const theme = getHeaderTheme();

const QuizCategoryFilter = ({ categories = [], selectedCategory, onSelect }) => {
  if (categories.length === 0) return null;

  return (
    <FilterContainer>
      <FilterLabel htmlFor="quiz-category-select">Categoría</FilterLabel>
      <Select
        id="quiz-category-select"
        value={selectedCategory || ""}
        onChange={(event) => {
          const value = event.target.value;
          onSelect(value || null);
        }}
      >
        <option value="">Todas las categorías</option>
        {categories.map((category) => (
          <option key={category} value={category}>
            {category}
          </option>
        ))}
      </Select>
    </FilterContainer>
  );
};

export default QuizCategoryFilter;

const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
  max-width: 320px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const FilterLabel = styled.label`
  font-size: 15px;
  font-weight: 500;
  color: #6b7280;
`;

const Select = styled.select`
  appearance: none;
  -webkit-appearance: none;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 36px 10px 12px;
  font-size: 16px;
  font-weight: 500;
  color: #111827;
  cursor: pointer;
  width: 100%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover,
  &:focus {
    border-color: ${theme.primary};
    outline: none;
    box-shadow: 0 0 0 2px ${theme.primaryTransparent || "rgba(0,0,0,0.08)"};
  }
`;
